import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Contacts from './Contacts';
import ContactsNone from './ContactsNone';

import { Modal } from '@vivaahealth/design-system';

interface Props {
  email: string | null;
  phoneNumber: string | null;
  open: boolean;
  code?: string;
  handleGenerateCode: (
    args:
      | { email: string; phoneNumber?: undefined }
      | { email?: undefined; phoneNumber: string },
  ) => Promise<void>;
  login: () => Promise<void>;
  onClose: () => void;
  setCode: (code?: string) => void;
}

const TwoFactor: React.FC<Props> = ({ open, onClose, ...props }) => {
  const { t } = useTranslation('login');
  useEffect(() => window.scrollTo(0, 0), [open]);
  const hasContacts = !!(props.email || props.phoneNumber);
  return (
    <Modal open={open} onClose={onClose} title={t('verifyYourIdentity')}>
      {hasContacts ? <Contacts {...props} /> : <ContactsNone />}
    </Modal>
  );
};

export default TwoFactor;
